module.exports = __webpack_public_path__ + "static/media/L_01_sp.147d8aba.jpg";